import { useCallback } from 'react';

import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { CHATIK_LINK, CHATIK_DIPLINK } from 'src/types/applicantServices';

type UseChatikLink = (chatId: number) => string;

export const useChatikLink = (): UseChatikLink => {
    const isWebMobile = useSelectorNonNullable((state) => state.isWebMobile);

    return useCallback(
        (chatId: number) => {
            if (isWebMobile) {
                return `${CHATIK_DIPLINK}&chat_id=${chatId}`;
            }
            return `${CHATIK_LINK}${chatId}`;
        },
        [isWebMobile]
    );
};

export default useChatikLink;
